<mat-drawer-container>
    <mat-drawer mode="over" #drawer class="p-16" autoFocus="false">
        <div class="fx-column">
            <span class="text bold">{{'DOCUMENTS_LIST.FILTERS.LABEL' | translate}}</span>
            <span class="text">{{'DOCUMENTS_LIST.FILTERS.HINT' | translate}}</span>

            <app-document-approval-select label="{{'DOCUMENT.APPROVAL' | translate}}" [multiple]="true"
                [emitOnInit]="false" class="mt-20 fx-flex" (change)="onDocumentApprovalChange($event)"
                [(value)]="filters.approval" [noAutomatic]="true">
            </app-document-approval-select>

            <app-document-class-select label="{{'ENTITIES.DOCUMENT_TYPES' | translate}}" [multiple]="true"
                [search]="true" [emitOnInit]="false" class="mt-10 fx-flex" (change)="onDocumentClassChange($event)"
                [(value)]="filters.documentClass" [noAutomatic]="true">
            </app-document-class-select>

            <app-trademark-family-select label="{{'ENTITIES.TRADEMARK_FAMILIES' | translate}}" [multiple]="true"
                [search]="true" class="mt-10 fx-flex" (change)="onTrademarkFamilyChange($event)"
                [(value)]="filters.trademarkFamily" [emitOnInit]="false">
            </app-trademark-family-select>

            <app-trademark-select label="{{'ENTITIES.TRADEMARKS' | translate}}" [multiple]="true" [search]="true"
                class="mt-10 fx-flex" (change)="onTrademarkChange($event)" [(value)]="filters.trademark"
                [emitOnInit]="false">
            </app-trademark-select>

            <app-nice-select label="{{'ENTITIES.NICE_CLASSIFICATION' | translate}}" [multiple]="true" [search]="true"
                class="mt-10 fx-flex" [(value)]="filters.classNumber" (change)="onNiceClassificationChange($event)"
                [emitOnInit]="false">
            </app-nice-select>

            <app-product-service-select label="{{'ENTITIES.PRODUCTS_SERVICES' | translate}}" [multiple]="true"
                [search]="true" class="mt-10 fx-flex" [(value)]="filters.productsServices"
                (change)="onProductServiceChange($event)" [emitOnInit]="false" [trademarks]="filters.trademark"
                [niceClassification]="filters.classNumber">
            </app-product-service-select>

            <app-territory-select label="{{'ENTITIES.TERRITORIES' | translate}}" [multiple]="true" [search]="true"
                class="mt-10 fx-flex" [(value)]="filters.territories" (change)="onTerritoryChange($event)"
                [emitOnInit]="false">
            </app-territory-select>

            <app-tag-select label="{{'ENTITIES.TAGS' | translate}}" [multiple]="true" [search]="true"
                class="mt-10 fx-flex" [(value)]="filters.tags" (change)="onTagChange($event)" [emitOnInit]="false">
            </app-tag-select>

            <app-daterangepicker label="{{'ENTITIES.PERIOD' | translate}}" [visuallyHiddenLabel]="true"
                [clearable]="true" placeholder="{{'ENTITIES.PERIOD' | translate}}" class="mt-10 fx-flex"
                (valueChange)="onPeriodChange($event)" [(value)]="filters.period">
            </app-daterangepicker>



            <button class="mt-20" [class.main-button]="filtersCount > 0" [class.button]="filtersCount === 0"
                (click)="closeDrawer()">
                {{(filtersCount > 0 ? 'ACTIONS.SEE_DOCUMENT' : 'ACTIONS.CLOSE') | translate}}
            </button>
        </div>
    </mat-drawer>

    <mat-drawer-content class="p-0">

        <ng-content></ng-content>

    </mat-drawer-content>
</mat-drawer-container>